module.exports = __webpack_public_path__ + "img/very-helpful-.d1a4b4ef.gif";